module.exports = __webpack_public_path__ + "static/media/energia-mobile.db5332cc.svg";